export const cilElevator = ["24 24","<path d='M12 1.425l-7.5 6.482v2.968h15v-2.968zM18 9.375h-12v-0.782l6-5.185 6 5.185z'></path><path d='M4.5 16.093l7.5 6.482 7.5-6.482v-2.968h-15zM6 14.625h12v0.782l-6 5.185-6-5.185z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-elevator.js
// module id = null
// module chunks = 